import { render, staticRenderFns } from "./MemberSection.vue?vue&type=template&id=23881057&"
import script from "./MemberSection.vue?vue&type=script&lang=ts&"
export * from "./MemberSection.vue?vue&type=script&lang=ts&"
import style0 from "./MemberSection.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports